import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import Box, { BoxProps } from '@primitive/Box';
import * as style from './Card.css';
import { CardDescription } from './Card.Description';
import { CardMeta } from './Card.Meta';
import { CardTitle } from './Card.Title';

export type CardBodyProps = BoxProps<'div'>;

export const CardBody = ({ children, ...props }: CardBodyProps) => {
  return (
    <Box {...props} {...mergePropsClassName(props, style.body)}>
      {children || (
        <>
          <CardTitle />
          <CardMeta />
          <CardDescription />
        </>
      )}
    </Box>
  );
};
